export const ENTITY_DESCRIPTION = {
  aboutTopElementContent: 1,

  ENTITY_TYPE: {
    sport: 0,
    competition: 1,
    competitor: 2,
    athlete: 3,
    preMatch: 4,
    postMatch: 5,
  },

  ACTION_TYPES: {
    onSeeMoreClick: 'onSeeMoreClick'
  },

  CLICK_TYPE: {
    expanded: 'expanded',
    collapsed: 'collapsed'
  },

  SECTION_NAME: {
    default: "ENTITY_DESCRIPTION",
    faq: "FAQ",
    standings: "ENTITY_DESCRIPTION_STANDINGS",
    groups: "ENTITY_DESCRIPTION_GROUPS",
    yesterday: "ENTITY_DESCRIPTION_YESTERDAY",
    tomorrow: "ENTITY_DESCRIPTION_TOMORROW",
    metaTitle: "META_TITLE",
    metaDescription: "META_DESCRIPTION",
  },

  ANALYTICS: {
    ACTION_TYPES: {
      onDisplay: 'onDisplay',
      onEntityClick: 'onEntityClick',
      onShowMoreClick: 'onShowMoreClick'
    },
  },
};
